/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import React, { useEffect, Fragment, useState } from "react";
import { connect } from "react-redux";
import { bool, func, arrayOf } from "prop-types";
import { isIOS } from "react-device-detect";
import * as i18n from "util/i18n";
import * as dateUtils from "util/date";
import { actions as afipPaymentLinkActions, selectors as afipPaymentLinkSelectors } from "reducers/afipPaymentLink";
import { selectors as accountsSelectors } from "reducers/accounts";
import Notification from "pages/_components/Notification";
import CarouselMultiItems from "pages/_components/CarouselMultiItems/CarouselMultiItems";
import MainContainer from "pages/_components/MainContainer";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomText from "pages/_components/CustomText/CustomText";
import I18n from "pages/_components/I18n";
import Button from "pages/_components/Button";
import Image from "pages/_components/Image";
import { ResponsiveHeader, DesktopButtons, MobileButtons } from "pages/_components/header";
import Action from "pages/_components/Action";
import { push } from "connected-react-router";
import TransactionsHistory from "pages/afipPaymentLink/servicesPayment/TransactionsHistory";
import { goBack } from "connected-react-router";

const ServicesPayment = (props) => {
    const { isDesktop, fetching, dispatch, paymentSchedule, isPaymentsFilterOpen } = props;
    const [itemsToDisplay, setItemsToDisplay] = useState([]);

    useEffect(() => {
        dispatch(afipPaymentLinkActions.listPaymentsHistory());
        dispatch(afipPaymentLinkActions.getPaymentSchedule({ isArcaPayment: false }));
    }, []);

    useEffect(() => {
        if (paymentSchedule && paymentSchedule.length > 0) {
            const aux = [];
            paymentSchedule.forEach((element) => {
                const { paymentDueList, codeLink, entityId, entityName, alias, categoryId } = element;
                if (paymentDueList && paymentDueList.length > 0) {
                    const list = paymentDueList;
                    list.forEach((item) => {
                        item.codeLink = codeLink;
                        item.entityId = entityId;
                        item.entityName = entityName;
                        item.alias = alias;
                        item.categoryId = categoryId;
                        item.id = `${item.codeLink}-${item.debtId}`;
                    });
                    aux.push(...list);
                }
            });
            setItemsToDisplay(
                aux.sort((a, b) => dateUtils.addUtcOffset(a.dueDate) - dateUtils.addUtcOffset(b.dueDate)),
            );
        }
    }, [paymentSchedule]);

    const itemsPerPage = 3;

    const options = [
        {
            text: "services.payment.link.schedule.services.menu",
            textType: "I18N",
            func: () => dispatch(push("/addService")),
        },
        {
            text: "services.payment.link.view.scheduled.services.menu",
            textType: "I18N",
            func: () => {
                dispatch(push("/servicePayments/linkedServices"));
            },
        },
    ];

    const payScheduledService = (serviceData) => {
        dispatch(afipPaymentLinkActions.setAddedServicePaymentData(serviceData));
        dispatch(push("/newServicePayment"));
    }

    const showLoader = fetching && !isPaymentsFilterOpen;

    const handleBack = () => {
         dispatch(push("/desktop"));
    };

    return (
        <>
            <Notification scopeToShow="servicesPayment" />
            <ResponsiveHeader id="menu.payments.service" onClickBack={handleBack}>
                <DesktopButtons moreOptions={options} secondButtonDisabled>
                    <Button
                        className="btn btn-primary btn-block small"
                        onClick={() => dispatch(push("/newServicePayment"))}>
                        <Image src="images/figma/icon/nuevo.svg" className="icon-medium svg-icon" />
                        <I18n id="services.payment.link.new.payment.btn" />
                    </Button>
                </DesktopButtons>

                <MobileButtons
                    image={isIOS ? "images/figma/icon/menu-ios-white.svg" : "images/figma/icon/menu-ios.svg"}>
                    <Action
                        labelKey="services.payment.link.new.payment.btn"
                        handleClick={() => dispatch(push("/newServicePayment"))}
                    />
                    <Action
                        labelKey="services.payment.link.schedule.services.menu"
                        handleClick={() => dispatch(push("/addService"))}
                    />
                    <Action
                        labelKey="services.payment.link.view.scheduled.services.menu"
                        handleClick={() => {
                            dispatch(push("/servicePayments/linkedServices"));
                        }}
                    />
                </MobileButtons>
            </ResponsiveHeader>
            <MainContainer showLoader={showLoader}>
                <div className="container">
                    <CustomText
                        text={i18n.get("services.payment.link.schedule.title", "Próximos vencimientos")}
                        textType="TEXT"
                        className="discounts-echeq-review__date-control"
                    />
                    <div className="pb-6" />
                    {itemsToDisplay && itemsToDisplay.length > 0 ? (
                        <Fragment>
                            <CarouselMultiItems
                                items={itemsToDisplay}
                                itemsPerPage={itemsPerPage}
                                isDesktop={isDesktop}
                                handleOnClick={(value) => payScheduledService(value)}
                            />
                        </Fragment>
                    ) : (
                        <div className="box info">
                            <CustomData
                                icon="information_fill.svg"
                                titleText="services.payment.link.schedule.empty"
                                titleTextType="I18N"
                            />
                        </div>
                    )}
                    <div className="pb-6" />
                </div>
                 <TransactionsHistory isDesktop={isDesktop}/>
            </MainContainer>
        </>
    );
};

ServicesPayment.propTypes = {
    isDesktop: bool,
    dispatch: func.isRequired,
    fetching: bool,
    paymentSchedule: arrayOf({}).isRequired,
};

ServicesPayment.defaultProps = {
    isDesktop: true,
    fetching: false,
};

const mapStateToProps = (state) => ({
    fetching: afipPaymentLinkSelectors.getFetching(state),
    paymentSchedule: afipPaymentLinkSelectors.getPaymentSchedule(state),
    accounts: accountsSelectors.getAccounts(state),
    isPaymentsFilterOpen: afipPaymentLinkSelectors.isPaymentsFilterOpen(state),
});

export default connect(mapStateToProps)(ServicesPayment);
